var map = {
	"./symbol_0.png": "5cf1",
	"./symbol_1.png": "c21b",
	"./symbol_2.png": "f90b",
	"./symbol_3.png": "b9d6",
	"./symbol_4.png": "00ca",
	"./symbol_5.png": "f698",
	"./symbol_6.png": "8129"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16b9";